export const getSelector = (reducerType, value) => {
  return (state) => state[reducerType][value];
};
export const getSelectors = (reducerType) => {
  return (state) => state[reducerType];
};
